/* src/app/components/review/redaction-annotation/page-edits-view/page-edits-view.component.scss */
.column-text {
  white-space: unset !important;
  flex: 0 0 60% !important;
  width: 60% !important;
}
.column-color {
  flex: 0 0 20% !important;
  width: 20% !important;
}
.column-delete {
  flex: 0 0 20% !important;
  width: 20% !important;
}
.color-display {
  height: 20px;
  width: 20px;
  border: 1px solid gray;
  border-radius: 25px;
}
.color-display-select {
  height: 15px;
  width: 125px;
  margin-left: 25px;
}
.text-display {
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:host-context(.dark-theme) .selected-edit {
  background: rgba(255, 255, 255, 0.0784313725);
}
/*# sourceMappingURL=page-edits-view.component.css.map */
